import { useSelector } from "react-redux";
import { selectAllResources } from "../slices/resourceCollection/resourceCollectionSlice";
import { selectEditMode } from "../slices/editMode/editModeSlice";
import { selectOlderVersionFhirString, selectViewingOlderVersion } from "../slices/viewingOlderVersion/viewingOlderVersionSlice";
import { generateCitationSummaryFromFhirJson } from "../functions/generateHowToCite";
import MetadataPatternEdit from "./MetadataOfResourceEditing";
import SimpleResourceFieldViewer from "./SimpleResourceFieldViewer";
import { MetadataPatternDisplay } from "./MetadataPatternDisplay";
import NewTabLink from "../components/NewTabLink";
import { DisplayFromFHIRMarkdown } from "../datatypeComponents/MarkdownEntry";

const ResourceBottomDisplay = ({ fhirJson }) => {
    const editMode = useSelector(state => selectEditMode(state));
    const resourceCollection = useSelector(state => selectAllResources(state));
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const olderVersionFhirString = useSelector(state => selectOlderVersionFhirString(state));

    let fhirJsonToUse = fhirJson;
    if (viewingOlderVersion && olderVersionFhirString) {
        try {
            const olderVersionJson = JSON.parse(olderVersionFhirString);
            fhirJsonToUse = olderVersionJson;
        } catch {
            alert("Error viewing JSON of older version.");
        }
    }

    if (!fhirJsonToUse) {
        return <></>
    }

    let resourceType = fhirJsonToUse.resourceType;

    return <div>
        {resourceType !== "Citation" && <>
            <h3 id="how-to-cite">How to Cite</h3>
            <div style={{ marginLeft: "24px" }}>
                <DisplayFromFHIRMarkdown markdown={generateCitationSummaryFromFhirJson(fhirJsonToUse)} />
            </div>
        </>}
        {resourceType === "Citation"
            ?
            <h3 id="citation-metadata">Citation Metadata</h3>
            :
            <h3 id="metadata">Metadata</h3>
        }
        <div style={{ marginLeft: "24px" }}>
            {editMode ?
                <MetadataPatternEdit foi={fhirJson.id} />
                :
                <MetadataPatternDisplay fhirJson={fhirJsonToUse} />
            }
        </div>
        {resourceType !== "Citation" && <>
            <h3 id="associated-resources">Associated Resources</h3>
            {viewingOlderVersion &&
                <h4>NOTE: These are the Resources associated with the CURRENT version, not the older version you are viewing.</h4>}
            <div style={{ marginLeft: "24px" }}>
                {resourceCollection?.length > 1 ? <>
                    <div style={{ textAlign: "left" }}>
                        <p>Resources referenced by <b>{fhirJson.resourceType}: </b>{fhirJson.title || fhirJson.name || "this Resource"} (FOI {fhirJson.id}) include:</p>
                        {resourceCollection.map((entry, index) => {
                            const url = "/resources/" + entry.resourceType + "/" + entry.id;
                            return <div key={index}>
                                {entry.id === fhirJson.id ?
                                    <></>
                                    :
                                    <NewTabLink href={url} target={'foi-' + entry.id}>
                                        <b>{entry.resourceType}: </b>{entry.displayTitle} (FOI {entry.id})
                                    </NewTabLink>
                                }
                            </div>
                        })}
                    </div>
                </>
                    :
                    <p>No referenced Resources.</p>}
            </div>
        </>}
        <h3 id="json-outline">JSON Outline</h3>
        <SimpleResourceFieldViewer resource={fhirJsonToUse} parentElement={""} />
        <br /><br />
    </div>
}

export default ResourceBottomDisplay;